// extracted by mini-css-extract-plugin
export default {"PanelLayout":"PanelLayout__O89wI"};